import * as React from 'react';

const SvgCommandCenterFilled = props => {
  const { size = 24, fill } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={fill} height={size} width={size} {...props}>
      <path
        fill={fill}
        fillRule="evenodd"
        d="M8.655.472C3.985 1.825.489 5.938.047 10.93h5.486A27.023 27.023 0 018.655.472zm-3.122 12.6H.047c.442 4.99 3.938 9.103 8.608 10.456A27.023 27.023 0 015.533 13.07zm5.87 10.913a24.818 24.818 0 01-3.718-10.914h8.63a24.818 24.818 0 01-3.719 10.914 12.279 12.279 0 01-1.192 0zm3.942-.457c4.67-1.353 8.166-5.466 8.608-10.457h-5.486a27.022 27.022 0 01-3.122 10.457zm3.122-12.6h5.486c-.442-4.99-3.939-9.103-8.608-10.456a27.021 27.021 0 013.122 10.457zM11.404.016a12.199 12.199 0 011.192 0 24.818 24.818 0 013.719 10.914h-8.63A24.818 24.818 0 0111.404.015z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCommandCenterFilled;
